/*
 * Remplissage du Cerfa 16301*01 (Demande d'aides a l'autonomie a domicile pour les personnes agees).
 * Tout se passe dans le navigateur : aucune donnee n'est envoyee a un serveur.
 * Utilisable aussi en Node (tests) : ApaCerfa.fill(pdfBytes, data, PDFLib)
 */
(function (root) {
  'use strict';

  // Champs "une case par chiffre", dans l'ordre de lecture (gauche -> droite).
  var BOX = {
    dem_naiss: [220, 219, 218, 217, 216, 215, 214, 213],
    dem_nir: [209, 208, 207, 206, 205, 204, 203, 202, 201, 200, 199, 198, 197, 196, 195],
    dem_tel: [235, 234, 233, 232, 231, 230, 229, 228, 227, 226],
    dem_cp: [242, 241, 240, 239, 238],
    anc_cp: [252, 251, 250, 249, 248],
    anc_date: [261, 260, 259, 258, 257, 256, 255, 254],
    conj_naiss: [133, 132, 131, 130, 129, 128, 127, 126],
    conj_nir: [146, 145, 144, 143, 142, 141, 140, 139, 138, 137, 136, 135, 134, 148, 147],
    conj_ehpad: [160, 159, 158, 157, 156, 155, 154, 153],
    prot_cp: [171, 170, 169, 168, 167],
    prot_tel: [177, 176, 175, 174, 173, 182, 181, 180, 179, 178],
    proche_cp: [278, 277, 276, 275, 274],
    proche_tel: [272, 271, 270, 269, 268, 267, 266, 265, 264, 263],
    rp_cp: [288, 287, 286, 285, 284],
    bien1_cp: [295, 294, 293, 292, 291],
    bien2_cp: [302, 301, 300, 299, 298],
    bien3_cp: [309, 308, 307, 306, 305],
    sign_date: [324, 323, 322, 321, 320, 319, 318, 317],
    cert_naiss: [333, 332, 331, 330, 329, 328, 327, 326],
    cert_cp: [342, 341, 340, 339, 338]
  };

  // Champs texte simples.
  var TXT = {
    dem_nom: 223, dem_nom_usage: 222, dem_prenom: 221, dem_commune_naiss: 212,
    dem_dept_naiss: 211, dem_pays_naiss: 210, dem_caisse_autre: 364, dem_email: 225,
    dem_domicile_autre: 253, dem_adresse: 236, dem_commune: 237,
    dem_batiment: 374, dem_etage: 373, dem_digicode: 372,
    anc_adresse: 246, anc_commune: 247,
    conj_nom: 123, conj_nom_usage: 124, conj_prenom: 125, conj_commune_naiss: 149,
    conj_dept_naiss: 151, conj_pays_naiss: 152, conj_domicile_autre: 161,
    prot_organisme: 162, prot_nom: 163, prot_prenom: 164, prot_adresse: 165,
    prot_commune: 172, prot_email: 183,
    proche_nom: 281, proche_prenom: 280, proche_adresse: 279, proche_commune: 273,
    proche_email: 262, proche_lien_autre: 282,
    rp_adresse: 289, rp_commune: 283,
    bien1_adresse: 311, bien1_commune: 290, bien2_adresse: 312, bien2_commune: 297,
    bien3_adresse: 313, bien3_commune: 304,
    mob1_nature: 3010, mob1_montant: 3011, mob2_nature: 3012, mob2_montant: 3014,
    mob3_nature: 3013, mob3_montant: 3015,
    sign_nom: 315, sign_prenom: 314, sign_representant_de: 375, sign_lieu: 316,
    cert_nom: 336, cert_nom_usage: 335, cert_prenom: 334, cert_adresse: 343, cert_commune: 337
  };

  // Groupes de boutons radio : valeur -> index de l'option (ordre du formulaire papier).
  var RADIO = {
    dem_civilite: { n: 7, v: { madame: 0, monsieur: 1 } },
    dem_caisse: { n: 53, v: { assurance_retraite: 0, fonction_publique: 1, msa: 2, autre: 3 } },
    dem_domicile: { n: 8, v: { demandeur: 0, famille: 1, accueillant: 2, residence_autonomie: 3, autre: 4 } },
    situation: { n: 1, v: { celibataire: 0, marie: 1, pacse: 2, concubinage: 3, divorce: 4, veuf: 5 } },
    conj_civilite: { n: 2, v: { madame: 0, monsieur: 1 } },
    conj_domicile: { n: 3, v: { identique: 0, accueillant: 1, ehpad: 2, autre: 3 } },
    protection: { n: 4, v: { oui: 0, en_cours: 1, non: 2 } },
    protection_mesure: { n: 5, v: { sauvegarde: 0, curatelle_simple: 1, curatelle_renforcee: 2, tutelle: 3, habilitation: 4, mandat: 5 } },
    prot_civilite: { n: 6, v: { madame: 0, monsieur: 1 } },
    proche_civilite: { n: 9, v: { madame: 0, monsieur: 1 } },
    proche_lien: { n: 10, v: { conjoint: 0, enfant: 1, ami: 2, voisin: 3, autre: 4 } },
    auto_lever: { n: 11, v: { oui: 0, non: 1 } },
    auto_habiller: { n: 12, v: { oui: 0, non: 1 } },
    auto_toilette: { n: 13, v: { oui: 0, non: 1 } },
    auto_manger: { n: 14, v: { oui: 0, non: 1 } },
    presta_actp: { n: 15, v: { oui: 0, non: 1 } },
    presta_aide_sociale: { n: 16, v: { oui: 0, non: 1 } },
    presta_mtp: { n: 17, v: { oui: 0, non: 1 } },
    presta_pch: { n: 18, v: { oui: 0, non: 1 } },
    presta_pcrtp: { n: 19, v: { oui: 0, non: 1 } },
    rp_statut: { n: 20, v: { proprietaire: 0, locataire: 1 } },
    rp_occupation: { n: 21, v: { occupee: 0, louee: 1, non_louee: 2 } },
    cmi_stationnement: { n: 22, v: { oui: 0, non: 1 } },
    cmi_priorite: { n: 23, v: { oui: 0, non: 1 } },
    cmi_renouvellement: { n: 24, v: { oui: 0, non: 1 } },
    sign_civilite: { n: 25, v: { madame: 0, monsieur: 1 } },
    sign_qualite: { n: 26, v: { mon_nom: 0, representant: 1 } }
  };

  function digits(s) { return String(s == null ? '' : s).replace(/\D/g, ''); }

  // "1946-03-25" (input date) ou "25/03/1946" -> "25031946"
  function dateDigits(s) {
    s = String(s || '').trim();
    var m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return m[3] + m[2] + m[1];
    return digits(s);
  }

  function setText(form, num, value) {
    if (value == null || value === '') return;
    var f;
    try { f = form.getTextField('Champ de texte ' + num); } catch (e) { return; }
    f.setText(String(value));
  }

  function setBoxes(form, key, value, isDate) {
    var s = isDate ? dateDigits(value) : digits(value);
    var nums = BOX[key];
    if (!s) return;
    for (var i = 0; i < nums.length && i < s.length; i++) setText(form, nums[i], s.charAt(i));
  }

  // Les options de ces groupes s'appellent toutes "choix" : on selectionne par index d'etat d'apparence.
  function selectRadio(form, PDFLib, key, value) {
    var def = RADIO[key];
    if (!def || value == null || value === '' || !(value in def.v)) return;
    var idx = String(def.v[value]);
    var group;
    try { group = form.getRadioGroup("Case d'option " + def.n); } catch (e) { return; }
    var af = group.acroField;
    var on = PDFLib.PDFName.of(idx);
    var off = PDFLib.PDFName.of('Off');
    var widgets = af.getWidgets();
    var found = false;
    for (var i = 0; i < widgets.length; i++) {
      var w = widgets[i];
      var wOn = w.getOnValue();
      if (wOn && wOn.decodeText() === idx) { w.setAppearanceState(on); found = true; }
      else w.setAppearanceState(off);
    }
    if (found) af.dict.set(PDFLib.PDFName.of('V'), on);
  }

  // Cadre "Signature" de la page 9 (coordonnees PDF du champ 325).
  var SIGN_BOX = { page: 8, x: 354, y: 387, w: 210, h: 71 };

  async function drawSignature(doc, png) {
    var img = await doc.embedPng(png);
    var page = doc.getPages()[SIGN_BOX.page];
    var pad = 4, maxW = SIGN_BOX.w - pad * 2, maxH = SIGN_BOX.h - 14; // laisse le libelle "Signature :" visible
    var s = Math.min(maxW / img.width, maxH / img.height);
    var w = img.width * s, h = img.height * s;
    page.drawImage(img, { x: SIGN_BOX.x + (SIGN_BOX.w - w) / 2, y: SIGN_BOX.y + pad, width: w, height: h });
  }

  async function fill(pdfBytes, data, PDFLib, opts) {
    opts = opts || {};
    var doc = await PDFLib.PDFDocument.load(pdfBytes);
    var form = doc.getForm();
    var k;
    for (k in TXT) if (Object.prototype.hasOwnProperty.call(data, k)) setText(form, TXT[k], data[k]);
    for (k in BOX) {
      if (!Object.prototype.hasOwnProperty.call(data, k)) continue;
      var isDate = /naiss|date|ehpad/.test(k);
      setBoxes(form, k, data[k], isDate);
    }
    for (k in RADIO) if (Object.prototype.hasOwnProperty.call(data, k)) selectRadio(form, PDFLib, k, data[k]);
    if (opts.signaturePng) await drawSignature(doc, opts.signaturePng);
    doc.setTitle('Demande APA - Cerfa 16301*01');
    return doc.save();
  }

  // Regle du formulaire (page 7, partie 4) : 2 "Non" ou plus -> departement (APA), sinon caisse de retraite.
  function organisme(data) {
    var non = ['auto_lever', 'auto_habiller', 'auto_toilette', 'auto_manger']
      .filter(function (q) { return data[q] === 'non'; }).length;
    return non >= 2 ? 'departement' : 'caisse';
  }

  var api = { fill: fill, organisme: organisme, _maps: { BOX: BOX, TXT: TXT, RADIO: RADIO } };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.ApaCerfa = api;
})(typeof window !== 'undefined' ? window : this);
